import React from "react";
import "./StatsSkeleton.scss";

/* ================= UAdmin trend CARD SKELETON ================= */
export const TrendSkeleton = () => {
    return (

        <div className="Trend_skeleton_text"></div>
    );
};

export const UserSkeleton = () => {
    return (
        <div className="User_skeleton">
            <div className="User_skeleton_icon"></div>
            <div className="User_skeleton_text_wrapper">
                <div className="User_skeleton_text"></div>
                <div className="User_skeleton_sub"></div>
            </div>
        </div>
    );
};

/* ================= Billing CARD SKELETON ================= */
export const BillingCardSkeleton = () => {
    return (
        <div className="Billing_skeleton">
            <div className="Billing_skeleton_text1"></div>
            <div className="Billing_skeleton_text2"></div>
            <div className="Billing_skeleton_text3"></div>
        </div>
    );
};

/* ================= STATS CARD SKELETON ================= */
export const StatsSkeleton = () => {
    return (
        <div className="stats_skeleton">
            <div className="skeleton_icon"></div>
            <div className="skeleton_text"></div>
            <div className="skeleton_sub"></div>
        </div>
    );
};

/* ================= LINE CHART SKELETON ================= */
export const LineSkeleton = () => {
    return (
        <div className="linechart_skeleton">
            <div className="skeleton_header"></div>

            <div className="chart_area">
                {[...Array(8)].map((_, i) => (
                    <div key={i} className="bar"></div>
                ))}
            </div>
        </div>
    );
};

/* ================= PIE CHART SKELETON ================= */
export const PieSkeleton = () => {
    return (
        <div className="piechart_skeleton">
            <div className="skeleton_header"></div>
            <div className="pie_circle"></div>

            <div className="pie_labelss">
                <div className="pie_Skeleton"></div>
                <div className="pie_Skeleton"></div>
                <div className="pie_Skeleton"></div>
            </div>
        </div>
    );
};

/* ================= row Line SKELETON ================= */
export const RowLineSkeleton = () => {
    return (

        <div className="skeleton_Line_row"></div>
    );
};

/* ================= TABLE SKELETON ================= */
export const TableSkeleton = ({columns = 5, rows = 6}) => {
    return (
        <div className="table_skeleton">

            {/* header */}
            <div className="table_row header">
                {[...Array(columns)].map((_, i) => (
                    <div key={i} className="cell header_cell"></div>
                ))}
            </div>

            {/* body */}
            {[...Array(rows)].map((_, r) => (
                <div key={r} className="table_row">
                    {[...Array(columns)].map((_, c) => (
                        <div key={c} className="cell"></div>
                    ))}
                </div>
            ))}

        </div>
    );
};